module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row d-flex align-items-end wrapper mt-5 pb-3"
  }, [_c('div', {
    staticClass: "col-12 col-sm-4 d-none d-sm-block"
  }, [_c('img', {
    staticClass: "img-fluid rounded",
    attrs: {
      "src": _vm.kotoriImg
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-8 align-self-center"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('img', {
    staticClass: "kotori img-fluid rounded col-4 d-block d-sm-none d-md-none d-lg-none",
    attrs: {
      "src": _vm.kotoriImg
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "mt-2 mb-4 mb-sm-3 mt-sm-3 mb-lg-4 text-kotori col col-sm-12 text-center align-self-center"
  }, [_vm._v("API")])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center form-pc"
  }, [_c('ul', [_c('li', [_vm._v(_vm._s(_vm.$t('method')) + "GET/POST")]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('address'))), _c('a', {
    attrs: {
      "href": _vm.apiUrl
    }
  }, [_vm._v(_vm._s(_vm.apiUrl))])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('parameters'))), _c('br'), _vm._v(" "), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.$t('url')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('title')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('format')))])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c472dec","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/api.vue
// module id = 43
// module chunks = 0